import React from 'react';
import { alpha } from '@mui/material/styles';
import {
  Box, Button, Stack, Typography,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

/**
 * Shared Studio layout: soft gradient backdrop, consistent horizontal rhythm,
 * optional back link and title row for list/edit pages.
 */
export default function StudioPageShell({
  title,
  subtitle,
  actions = null,
  backTo = null,
  backLabel = 'Back',
  maxWidth = 1200,
  contentTransition = false,
  children,
}) {
  return (
    <Box
      sx={{
        minHeight: '100%',
        background: (theme) => `linear-gradient(165deg, ${alpha(theme.palette.primary.main, 0.09)} 0%, ${theme.palette.background.default} 38%, ${theme.palette.background.default} 100%)`,
        pb: 6,
      }}
    >
      <Box
        sx={{
          maxWidth,
          mx: 'auto',
          width: '100%',
          px: { xs: 2, sm: 3 },
          pt: 3,
          transition: contentTransition ? 'max-width 0.2s ease' : undefined,
        }}
      >
        <Stack spacing={1} sx={{ mb: 3 }}>
          {backTo ? (
            <Button
              component={RouterLink}
              to={backTo}
              size="small"
              sx={{ alignSelf: 'flex-start', textTransform: 'none', fontWeight: 500 }}
            >
              ←
              {' '}
              {backLabel}
            </Button>
          ) : null}
          <Stack
            direction="row"
            alignItems="flex-start"
            justifyContent="space-between"
            gap={2}
            flexWrap="wrap"
          >
            <Box sx={{ minWidth: 0 }}>
              <Typography
                variant="h4"
                component="h1"
                sx={{ fontWeight: 700, letterSpacing: '-0.02em', lineHeight: 1.2 }}
              >
                {title}
              </Typography>
              {subtitle ? (
                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ mt: 0.75, maxWidth: 720 }}
                >
                  {subtitle}
                </Typography>
              ) : null}
            </Box>
            {actions ? (
              <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', flexShrink: 0, alignItems: 'center' }}>
                {actions}
              </Box>
            ) : null}
          </Stack>
        </Stack>
        {children}
      </Box>
    </Box>
  );
}
